import React, { useContext } from 'react';
import style from './index.module.css';
import { AppContext } from '../../../app';
import { connectSortBy } from 'react-instantsearch-dom';
import { Dropdown } from '../../../atoms/dropdown';
import { trackSortApplied } from '../../../utils/segmentTracking';
import Radio from '../../radio';

const SortBy = ({ type, items, refine }: any) => {
    if (items.length === 0) {
        return null;
    }

    const appContext = useContext(AppContext);

    if (type === 'radio') {
        return (
            <div className={style.radioWrapper}>
                <ul className={style.options}>
                    {items.map((item) => (
                        <li key={item.label}>
                            <Radio
                                label={item.label}
                                checked={item.isRefined}
                                onChange={() => {
                                    trackSortApplied({
                                        searchQuery: appContext.searchQuery,
                                        sort: item.label,
                                        tab: appContext.currentTab,
                                    });
                                    refine(item.value);
                                }}
                                name="sortBy"
                            />
                        </li>
                    ))}
                </ul>
            </div>
        );
    }

    const dropdownItems = items.map((item) => ({
        ...item,
        isSelected: item.isRefined,
    }));

    // Prevents empty "Sort by:" after switching to a tab that doesn't contain the current sort by value (eg: "Ending Soonest" within the CONTACTS tab)
    if (!dropdownItems.some((item) => item.isSelected === true)) {
        dropdownItems[0].isSelected = true;
        refine(items[0].value);
    }

    return (
        <div className={style.dropdownWrapper}>
            <Dropdown
                title="Sort By"
                items={dropdownItems}
                onClick={(value: string) => {
                    trackSortApplied({
                        searchQuery: appContext.searchQuery,
                        sort: items.find((item: any) => item.value === value)?.label,
                        tab: appContext.currentTab,
                    });
                    refine(value);
                }}
            />
        </div>
    );
};

const CustomSortBy = connectSortBy(SortBy);

export default CustomSortBy;
